import { render, staticRenderFns } from "./CreateShop.vue?vue&type=template&id=3576e57f&scoped=true"
import script from "./CreateShop.vue?vue&type=script&lang=js"
export * from "./CreateShop.vue?vue&type=script&lang=js"
import style0 from "./CreateShop.vue?vue&type=style&index=0&id=3576e57f&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3576e57f",
  null
  
)

export default component.exports